import { booleanAttribute, Component, effect, inject, input, signal } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UserService } from '../../user.service';
import { Authentication } from '../../authentication';
import { LanguageSwitcher } from '../language-switcher/language-switcher';
import { UserMenu } from '../user-menu/user-menu';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { RouterLink } from '@angular/router';
import { ProgressBarModule } from 'primeng/progressbar';
import { LoadingService } from '../../loading.service';

@Component({
  selector: 'app-navbar',
  imports: [TranslatePipe, LanguageSwitcher, UserMenu, ButtonModule, MenuModule, RouterLink, ProgressBarModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css',
})
export class Navbar {
  loadingService = inject(LoadingService);
  authentication = inject(Authentication);
  translate = inject(TranslateService);
  userService = inject(UserService);
  auth = inject(Authentication);

  mobileMenuOpen = signal(false);
  profileSubMenuOpen = signal(false);
  dealerSubMenuOpen = signal(false);

  transparent = input(false, { transform: booleanAttribute });
  showSellButton = signal(true);
  showDealerButton = signal(false);

  searchItems: MenuItem[] = [];

  constructor() {
    this.buildSearchItems();
    this.translate.onLangChange.subscribe(() => this.buildSearchItems());

    effect(() => {
      if (this.auth.user()) {
        const subscription = this.userService.getMe().subscribe((user) => {
          if (user.dealerId) {
            this.showSellButton.set(false);
            this.showDealerButton.set(true);
          }
        });
      }
    });
  }

  private buildSearchItems(): void {
    this.translate
      .get([
        'navbar.search.advanced.title',
        'navbar.search.advanced.subtitle',
        'navbar.search.dealer.title',
        'navbar.search.dealer.subtitle',
      ])
      .subscribe(() => {
        this.searchItems = [
          {
            title: this.translate.instant('navbar.search.advanced.title'),
            subtitle: this.translate.instant('navbar.search.advanced.subtitle'),
            icon: 'pi pi-sliders-h',
            link: '/search/advanced',
          },
          {
            title: this.translate.instant('navbar.search.dealer.title'),
            subtitle: this.translate.instant('navbar.search.dealer.subtitle'),
            icon: 'pi pi-building',
            link: '/search/dealer',
          },
        ];
      });
  }
}
